export default defineAppConfig({
    ui: {
        colors: {
            primary: 'blue',
            neutral: 'zinc'
        },
        avatar: {
            variants: {
              size: {
                '4xl': {root: 'h-24 w-24 text-4xl'},
                '5xl': {root: 'h-32 w-32 text-5xl'},
                '6xl': {root: 'h-40 w-40 text-6xl'},
              }
            }
        }
    },

    header: {
          links: [{
            label: 'Services pour',

            children: [{
              label: 'Association locale',
              description: 'Trouvez des bénévoles près de chez vous',
              to: '/association',
            }, {
              label: 'Siège d\'une association nationale',
              description: 'Accompagnez le bénévolat dans votre réseau',
              to: '/association/reseau',
            }, {
              label: 'Collectivité',
              description: 'Animez le tissu associatif de votre commune',
              to: '/collectivite',
            }, {
              label: 'Bénévole',
              description: 'Notre plateforme de bénévolat grand public',
              to: '/benevolt',
            }],
          }, {
            label: 'Solutions',

            children: [{
              label: 'Un outil centralisé pour gérer l\'engagement',
              description: 'Le pouvoir d\'un SaaS adapté aux associations',
              to: '/espace-asso',
            }, {
              label: 'Votre propre plateforme d\'engagement',
              description: 'Un site en marque blanche à vos couleurs',
              to: '/plateforme-engagement',
            }, {
              label: 'Expertise & formation',
              description: 'Accompagnez la transformation de votre association',
              to: '/expertise-formation',
            }, {
              label: 'Organiser une collecte',
              description: 'Notre outil de mobilisation pour vous faciliter la vie',
              to: '/organiser-collecte',
            }, {
              label: 'Plus qu\'un outil',
              description: 'Notre équipe vous accompagne au quotidien',
              to: '/accompagnement',
            }],
          }, {
            label: 'Ressources',

            children: [{
              label: 'Les petites astuces',
              to: '/petites-astuces',
            }, {
              label: 'Blog - La fabrique associative',
              to: '/ressources',
            }, {
              label: 'Guide - Culture Bénévole',
              to: '/guide-association-culture-benevole',
            }, {
              label: 'Petit dej\' interassociatif',
              to: '/petit-dej-interassociatif',
            }, {
              label: 'Guide - Gouvernance Associative - Tome 1',
              to: '/guide-gouvernance-associative-crise',
            }, {
              label: 'Guide - Gouvernance Associative - Tome 2',
              to: '/guide-gouvernance-associative-evolution',
            }, {
              label: 'Auto-diagnostic Gouvernance Associative',
              to: '/diagnostic-association',
            }, {
              label: 'Aide & FAQ',
              to: 'https://aide.benevolt.fr',
              external: true,
              target: '_blank',
            }],
          }],
      },

    footer: {
          links: [{
            label: 'Qui sommes-nous ?',

            children: [{
              label: 'À propos',
              to: '/a-propos',
              external: true,
            }, {
              label: 'Équipe',
              to: '/equipe',
            }, {
              label: 'Presse',
              to: '/presse',
            }, {
              label: 'Partenaires',
              to: '/partenariat',
            }],
          }, {
            label: 'Pour aller plus loin',

            children: [{
              label: 'Centre d\'aide',
              to: 'https://aide.benevolt.fr',
              target: '_blank',
              external: true,
            }, {
              label: 'Blog - La Fabrique associative',
              to: '/ressources',
            }, {
              label: 'Petites Astuces associatives',
              to: '/petites-astuces',
            }],
          }]
      },
})